<template>
  <div>
    <validation-observer #default="{handleSubmit}">
      <b-form @submit.prevent>
        <role-inputs
          :role="role"
          :grouped-permissions="groupedPermissions"
        />

        <b-row>
          <b-col>
            <b-button
              variant="outline-primary"
              class="btn-pill"
              @click="$router.back()"
            >
              Cancel
            </b-button>
          </b-col>
          <b-col class="text-right">
            <submit-button
              :disabled="!role.permissions.length"
              v-bind="{submit,handleSubmit}"
            />
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import SubmitButton from '@/components/FormInputs/SubmitButton.vue'
import Permissions from '@/compositions/TeamManagement/Permissions/PermissionsAPI'
import RoleInputs from './RoleInputs.vue'

export default {
  name: 'RoleForm',
  components: { SubmitButton, RoleInputs },
  props: {
    role: { type: Object, default: () => {} },
    submit: { type: Function, default: () => {} },
  },
  data() {
    return {
      groupedPermissions: [],
    }
  },
  setup() {
    const { indexRequest } = Permissions()
    return { indexRequest }
  },
  created() {
    this.getPermissions()
  },
  methods: {
    getPermissions() {
      this.indexRequest(this.$auth.id, this.$orgId, { scopeType: 'entity' }).then(res => {
        this.groupedPermissions = res.data.data
      })
    },
  },
}
</script>

<style>

</style>
